module.exports = __webpack_public_path__ + "static/img/download.1315f46b.png";